module.exports = __webpack_public_path__ + "static/media/28.a09069d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/28.jpg
// module id = 589
// module chunks = 0